import React, { useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';

interface AdSenseRailProps {
  className?: string;
}

export const AdSenseRail: React.FC<AdSenseRailProps> = ({ className = '' }) => {
  const adsenseClientId = process.env.REACT_APP_ADSENSE_CLIENT_ID;
  const { subscriptionStatus } = useAuth();
  
  // Hide ads for premium users
  const isPremium = subscriptionStatus?.subscription_status === 'active';
  
  useEffect(() => {
    // Initialize AdSense ads when component mounts and is visible
    if (adsenseClientId && typeof window !== 'undefined' && (window as any).adsbygoogle) {
      // Add a small delay to ensure the container is rendered with proper dimensions
      const timer = setTimeout(() => {
        try {
          ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push({});
        } catch (e) {
          console.error('AdSense error:', e);
        }
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [adsenseClientId]);
  
  // Don't render ads for premium users
  if (isPremium) {
    return null;
  }

  return (
    <div className={`hidden lg:block ${className}`}>
      <div className="sticky top-6">
        {adsenseClientId ? (
          // Real AdSense ads when client ID is configured
          <>
            {/* First Ad Unit */}
            <div className="mb-4 w-48 min-h-[600px]">
              <ins 
                className="adsbygoogle"
                style={{ display: 'block', width: '192px', minHeight: '600px' }}
                data-ad-client="ca-pub-8917437402254543"
                data-ad-slot="7862857381"
                data-ad-format="auto"
                data-full-width-responsive="true"
              ></ins>
            </div>
            
            {/* Second Ad Unit */}
            <div className="w-48 min-h-[600px]">
              <ins 
                className="adsbygoogle"
                style={{ display: 'block', width: '192px', minHeight: '600px' }}
                data-ad-client="ca-pub-8917437402254543"
                data-ad-slot="1241608710"
                data-ad-format="auto"
                data-full-width-responsive="true"
              ></ins>
            </div>
          </>
        ) : (
          // Placeholder during development
          <>
            <div className="bg-gray-100 border border-gray-200 rounded-lg p-4 text-center">
              <div className="w-48 h-96 flex items-center justify-center">
                <div className="text-gray-500 text-sm">
                  <div className="mb-2">📢</div>
                  <div className="font-medium">Ad Space</div>
                  <div className="text-xs mt-1">
                    Google AdSense
                    <br />
                    (300x600)
                    <br />
                    <span className="text-gray-400">Not configured</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="mt-4 bg-gray-100 border border-gray-200 rounded-lg p-4 text-center">
              <div className="w-48 h-96 flex items-center justify-center">
                <div className="text-gray-500 text-sm">
                  <div className="mb-2">📢</div>
                  <div className="font-medium">Ad Space</div>
                  <div className="text-xs mt-1">
                    Google AdSense
                    <br />
                    (300x600)
                    <br />
                    <span className="text-gray-400">Not configured</span>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
